import {Pane, TpChangeEvent} from 'tweakpane';

export default function createFeatureFlagsPane<T extends string>(
  container: HTMLDivElement,
  data: {[key in T]: boolean},
  toggleHidden: () => void,
  onChange: (key: T, value: boolean) => void,
): void {
  const pane = new Pane({container});

  pane.addButton({title: 'FF'}).on('click', toggleHidden);

  (Object.keys(data) as T[]).forEach(key =>
    pane
      .addBinding(data, key)
      .on('change', (e: TpChangeEvent<boolean>) => onChange(key, e.value)),
  );
}
